<template>
  <div class="merchant">
    <div
      class="flex justify-between items-center pb-6 shadow-border-b mdmax:shadow-none mdmax:flex-col"
    >
      <div class="flex-1 mdmax:flex-auto mdmax:w-full mdmax:mb-2">
        <LinkButton
          buttonText="Tambah Merchant"
          url="/merchant/create"
          linkType="internal"
          :size="isMobile ? 'full' : 'regular'"
        />
      </div>
      <!-- <div class="flex-1 flex justify-end mdmax:flex-auto mdmax:w-full mdmax:justify-start">
        <div class="w-3/5  mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Pencarian nama, no hp, cabang. area" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="isMobile">
      Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <span class="flex gap-2" v-if="column.field === 'action'">
          <Button
            v-if="!entry.is_upgraded"
            @action="upgrade(entry.id)"
            buttonText="Upgrade"
            type="primary"
            size="small"
          />
          <span class="flex items-center gap-2">
            <Toggle
              :value="!!entry.is_active_api"
              :id="`merchant-onoff-${entry.id}`"
              @input="toggleOnOff(entry, $event)"
            />
            <span class="text-xs font-semibold text-neutral-600">
              {{ entry.is_active_api ? "On" : "Off" }}
            </span>
          </span>
          <LinkButton
            buttonText="Lihat rincian"
            :url="`/merchant/detail/${entry.id}`"
            linkType="internal"
            type="secondary"
            size="small"
          />
        </span>
        <span class="block" v-else-if="column.field === 'id'">
          {{ entry[column.field] }}
        </span>
        <span class="block" v-else-if="column.field === 'sender_name'">
          {{ entry.merchant_place.sender_name }}
        </span>
        <span class="block" v-else-if="column.field === 'phone_number'">
          {{ entry.merchant_place.phone_number }}
        </span>
        <span class="block" v-else-if="column.field === 'is_upgraded'">
          <span
            class="inline-block px-2 py-1 rounded text-xs whitespace-nowrap w-full text-center font-extrabold"
            :class="{
              'bg-green-100 text-green-700': entry[column.field],
              'bg-gray-100 text-gray-700': !entry[column.field]
            }"
          >
            {{ entry[column.field] ? "VIP" : "Non-VIP" }}
          </span>
        </span>
        <span v-else>{{ entry[column.field] }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">
      Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}
    </div>
    <div
      class="mt-8 flex justify-center items-center mb-6"
      v-if="filteredData && filteredData.length > 0"
    >
      <pagination
        :currentPage="currentPage"
        :totalCount="totalRecords"
        :pageSize="pageSize"
        @onPageChange="onPageChange"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
export default {
  components: {
    // TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/LinkButton"),
    Button: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/Button"),
    Toggle: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Toggle/Toggle"),
    // Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    TableComponent: () =>
      import(/* webpackChunkName: "Table" */ "@/components/Table/Table"),
    Pagination: () =>
      import(
        /* webpackChunkName: "Pagination" */ "@/components/Pagination/Pagination"
      )
  },
  data() {
    return {
      searchTerm: "",
      isModalVisible: false,
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true,
      columns: [
        { label: "ID", field: "id" },
        { label: "Business Merchant", field: "merchant" },
        { label: "Nama Admin Pengirim", field: "sender_name" },
        { label: "No. Handphone", field: "phone_number" },
        { label: "Email", field: "merchant_email" },
        { label: "Status", field: "is_upgraded" },
        { label: "Action", field: "action" }
      ]
    }
  },
  computed: {
    ...mapGetters("common", ["isMobile"]),
    ...mapGetters("merchant", ["merchants"]),
    filteredData() {
      let temp = this.merchants
      temp = temp.filter((item) => {
        return item.code !== ""
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: "/merchant", query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getListMerchant()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getListMerchant()
      } else {
        this.$router.push({ path: "/merchant", query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions("merchant", [
      "getMerchants",
      "upgradeMerchant",
      "updateApiKeyStatus"
    ]),
    ...mapActions("common", ["showLoading", "hideLoading", "setToast"]),
    getListMerchant() {
      this.showLoading()
      this.getMerchants({
        params: {
          page: this.currentPage,
          per_page: this.pageSize
        }
      })
        .then((merchantRes) => {
          this.totalRecords = merchantRes.data.meta.total_item
        })
        .catch(() => {
          // noop: loading is handled in finally
        })
        .finally(() => {
          this.hideLoading()
        })
    },
    upgrade(merchantId) {
      console.log("test")
      this.showLoading()
      this.upgradeMerchant({
        payloads: {
          merchant_id: merchantId
        }
      })
        .then(() => {
          this.hideLoading()
          console.log("then")

          this.setToast({
            options: {
              type: "success",
              duration: 2000,
              primaryText: "Upgrade Merchant Berhasil",
              secondaryText: "Data telah kami simpan"
            }
          })
          this.getListMerchant()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    toggleOnOff(entry, nextValue) {
      if (nextValue === !!entry.is_active_api) {
        return
      }
      this.showLoading()
      this.updateApiKeyStatus({
        id: entry.id,
        payloads: {
          is_active_api: nextValue
        }
      })
        .then(() => {
          return this.getMerchants({
            params: {
              page: this.currentPage,
              per_page: this.pageSize
            }
          })
        })
        .then((merchantRes) => {
          this.totalRecords = merchantRes.data.meta.total_item
          this.setToast({
            options: {
              type: "success",
              duration: 2000,
              primaryText: "Status API Key diperbarui",
              secondaryText: `API Key ${nextValue ? "aktif" : "nonaktif"}`
            }
          })
        })
        .catch(() => {
          this.setToast({
            options: {
              type: "error",
              duration: 2000,
              primaryText: "Gagal memperbarui status API Key",
              secondaryText: "Silakan coba lagi"
            }
          })
        })
        .finally(() => {
          this.hideLoading()
        })
    },
    handleCallback() {
      this.$router.push("/merchant")
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: "/merchant", query: { page: page } })
    }
  }
}
</script>
